import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import HTML from 'molecules/HTML';

import './FooterClone.css';


const FooterClone = React.memo( p => {

  return(

    <div
    dangerouslySetInnerHTML={ { __html: `
      <div class="l-footer__content" style="background-image: url('https://www.dartdrones.com/wp-content/uploads/2016/05/footer-bg.jpg')">
       	<div class="row">
       		<div class="column">


       		<!-- NAV COLUMNS -->
       		<div class="l-footer__content-nav-wrap">


      				<nav class="l-footer__content-nav">
      					<h2 class="heading js-ftcollapse">About Us<i class="ddicon-caret"></i></h2>


      						<ul class="clean-list">



      									<li>
      										<a href="https://www.dartdrones.com/about-us/">Company</a>
      									</li>



      									<li>
      										<a href="https://www.dartdrones.com/press/">Press</a>
      									</li>



      									<li>
      										<a href="https://www.dartdrones.com/contact-us/">Contact</a>
      									</li>



      									<li>
      										<a href="https://www.dartdrones.com/blog/">Blog</a>
      									</li>



      									<li>
      										<a href="https://www.dartdrones.com/our-policies/">Our Policies</a>
      									</li>



      									<li>
      										<a href="https://www.dartdrones.com/partners/">Partners</a>
      									</li>



      									<li>
      										<a href="https://www.dartdrones.com/openpositions-2/">Careers</a>
      									</li>



      									<li>
      										<a href="https://www.dartdrones.com/product/gift-certificate/">Gift Cards</a>
      									</li>


      						</ul>


      				</nav><!-- .l-footer__content-nav -->


      				<nav class="l-footer__content-nav">
      					<h2 class="heading js-ftcollapse">Drone Courses<i class="ddicon-caret"></i></h2>


      						<ul class="clean-list">



      									<li>
      										<a href="https://www.dartdrones.com/drone-pilot-training-package/">Professional Drone Pilot Package</a>
      									</li>



      									<li>
      										<a href="https://www.dartdrones.com/drone-pilot-training/">In-Person Flight Training: Phantom, Mavic, Inspire</a>
      									</li>



      									<li>
      										<a href="https://www.dartdrones.com/part-107-commercial-drone-license/">In-Person Part 107 Training</a>
      									</li>



      									<li>
      										<a href="https://www.dartdrones.com/part-107-online/">Online Part 107 Training</a>
      									</li>



      									<li>
      										<a href="https://www.dartdrones.com/trusted-operator-program-level-1-certification/">Trusted Operator Program™ Level 1 Certification</a>
      									</li>



      									<li>
      										<a href="https://www.dartdrones.com/trusted-operator-program-level-2-certification/">Trusted Operator Program™ Level 2 Certification</a>
      									</li>



      									<li>
      										<a href="https://www.dartdrones.com/real-world-flight-planning-execution-program/">Real-World Flight Planning &amp; Execution Program</a>
      									</li>



      									<li>
      										<a href="https://www.dartdrones.com/drone-mapping/">Aerial Mapping and Modeling Workshop</a>
      									</li>



      									<li>
      										<a href="https://www.dartdrones.com/drone-roof-inspections/">Aerial Drone Inspections Workshop</a>
      									</li>



      									<li>
      										<a href="https://www.dartdrones.com/disaster-response-drone-training/">Disaster Response</a>
      									</li>



      									<li>
      										<a href="https://www.dartdrones.com/night-flight-drone-training/">Night Flight Package</a>
      									</li>



      									<li>
      										<a href="https://www.dartdrones.com/online-courses/drones-for-beginners/">Drones for Beginners Online</a>
      									</li>



      									<li>
      										<a href="https://www.dartdrones.com/aerial-photography/">Aerial Photography Online</a>
      									</li>



      									<li>
      										<a href="https://www.dartdrones.com/drone-business-part-107/">Starting a Drone Business Online</a>
      									</li>


      						</ul>


      				</nav><!-- .l-footer__content-nav -->


      				<nav class="l-footer__content-nav">
      					<h2 class="heading js-ftcollapse">Custom Drone Training<i class="ddicon-caret"></i></h2>


      						<ul class="clean-list">



      									<li>
      										<a href="https://www.dartdrones.com/custom-on-site-uav-training-for-organizations/">Enterprise Training</a>
      									</li>



      									<li>
      										<a href="https://www.dartdrones.com/drone-consulting-services/">Consulting</a>
      									</li>


      						</ul>


      				</nav><!-- .l-footer__content-nav -->


      		</div><!-- .l-footer__nav-wrap -->



       		<!-- GALLERY? -->


       		<!-- LOGO -->
       		<div class="l-footer__content-profile">
       			<img src="https://www.dartdrones.com/wp-content/uploads/2016/05/dartdrones-logo-stacked-white.svg" alt="DARTdrones">
       		</div>


       		<!-- BOTTOMS -->
       		<div class="clearfix"></div>
       		<div class="l-footer__content-bottom">

       			<span class="copyright">© 2019 DARTdrones Inc.</span>
       			<p>All rights reserved. &nbsp; Privacy &nbsp; Terms &amp; Conditions</p>

       		</div><!-- .l-footer__bottom -->

      		</div>
       	</div>
       </div>
    ` } }
    />


  )
} );
export default FooterClone;




